import { Navigate } from "react-router-dom";
import { useUserAuth } from "../../context";
import { freeWorkflows } from "../../context/authentication/UserAuthContext";
import {
  isNotSubscribed,
  isWorkflowRestricted,
} from "../../context/authentication/userWorkflowValidation";

type Props = {
  children?: JSX.Element;
  section: string;
};

function ProtectedRoute({ children, section }: Props): JSX.Element {
  let {
    user,
    accessWorkflows,
    worklowValidation,
    userSubscription,
    razorpaySubInfo,
  } = useUserAuth();

  /*
      - If : section is not included in freeworkflow and access workflows array
            then - Redirect to home page 
      - Else If : check custom workflows access and subscription if both true then redirect it to home page
            then - Redirect to home page
        Else
            then - Redirect to section page.
  */

  if (!user) {
    return <Navigate to="/user/login"></Navigate>;
  }
  else if (
    isWorkflowRestricted(
      worklowValidation,
      section,
      freeWorkflows,
      accessWorkflows
    ) &&
    isNotSubscribed(section, freeWorkflows, userSubscription, razorpaySubInfo)
  ) {
    return <Navigate to="/"></Navigate>;
  }
  return children;
}

export default ProtectedRoute;
